import { Navbar } from '../bordeaux/components/Navbar';
import { Hero } from '../bordeaux/components/Hero';
import { Services } from '../bordeaux/components/Services';
import { BayWindows } from '../bordeaux/components/BayWindows';
import { WhatsAppDiagnostic } from '../bordeaux/components/WhatsAppDiagnostic';
import { Contact } from '../bordeaux/components/Contact';
import { Footer } from '../bordeaux/components/Footer';
import { useEffect } from 'react';

export default function Eysines() {
  useEffect(() => {
    document.title = "Réparation Fenêtres Eysines | PVC Alu Bois | Baies Vitrées | FenetrePro";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert en réparation de fenêtres à Eysines ✓ PVC, Aluminium, Bois ✓ Baies vitrées toutes marques ✓ Intervention rapide ✓ Devis gratuit ✓ Artisan local Eysines');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Eysines, fenêtres PVC Eysines, fenêtres aluminium Eysines, baies vitrées Eysines, vitrier Eysines');
    }

    // Open Graph tags
    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement('meta');
      ogType.setAttribute('property', 'og:type');
      document.head.appendChild(ogType);
    }
    ogType.setAttribute('content', 'website');

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', 'https://reparation-fenetre-bordeaux.fr/eysines');

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'Réparation Fenêtres Eysines | PVC Alu Bois | Baies Vitrées | FenetrePro');

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', 'Expert en réparation de fenêtres à Eysines ✓ PVC, Aluminium, Bois ✓ Baies vitrées toutes marques ✓ Intervention rapide ✓ Devis gratuit ✓ Artisan local Eysines');

    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute('content', 'https://public.readdy.ai/ai/img_res/92f440a483e101fa68c114fa126066aa.jpg');

    let ogImageWidth = document.querySelector('meta[property="og:image:width"]');
    if (!ogImageWidth) {
      ogImageWidth = document.createElement('meta');
      ogImageWidth.setAttribute('property', 'og:image:width');
      document.head.appendChild(ogImageWidth);
    }
    ogImageWidth.setAttribute('content', '1200');

    let ogImageHeight = document.querySelector('meta[property="og:image:height"]');
    if (!ogImageHeight) {
      ogImageHeight = document.createElement('meta');
      ogImageHeight.setAttribute('property', 'og:image:height');
      document.head.appendChild(ogImageHeight);
    }
    ogImageHeight.setAttribute('content', '630');

    const metaGeoPosition = document.querySelector('meta[name="geo.position"]');
    if (metaGeoPosition) {
      metaGeoPosition.setAttribute('content', '44.8833;-0.6500');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.position';
      meta.content = '44.8833;-0.6500';
      document.head.appendChild(meta);
    }

    const metaGeoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (metaGeoPlacename) {
      metaGeoPlacename.setAttribute('content', 'Eysines, Gironde, France');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.placename';
      meta.content = 'Eysines, Gironde, France';
      document.head.appendChild(meta);
    }

    const metaGeoRegion = document.querySelector('meta[name="geo.region"]');
    if (metaGeoRegion) {
      metaGeoRegion.setAttribute('content', 'FR-33');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.region';
      meta.content = 'FR-33';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar city="Eysines" />
      <Hero city="Eysines" />
      <Services city="Eysines" />
      <BayWindows city="Eysines" />
      <WhatsAppDiagnostic city="Eysines" />
      <Contact city="Eysines" />
      <Footer city="Eysines" />
    </div>
  );
}